module.exports = __webpack_public_path__ + "img/1694135777205-a8ff67df-4a91-4d48-958e-c183f1e131bf.jpeg.7e776c0f.webp";